import React, { useState } from 'react';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../services/api';

const emptyForm = { nome: '', descricao: '' };

export default function TipoPersianasPage() {
  const qc = useQueryClient();
  const [showForm, setShowForm] = useState(false);
  const [editId, setEditId] = useState<string | null>(null);
  const [form, setForm] = useState(emptyForm);

  const { data: tipos = [], isLoading } = useQuery({
    queryKey: ['tipos-persiana'],
    queryFn: () => api.get('/tipos-persiana').then(r => r.data),
  });

  const saveMutation = useMutation({
    mutationFn: (data: any) => editId ? api.put(`/tipos-persiana/${editId}`, data) : api.post('/tipos-persiana', data),
    onSuccess: () => { qc.invalidateQueries({ queryKey: ['tipos-persiana'] }); setShowForm(false); },
  });

  const toggleMutation = useMutation({
    mutationFn: ({ id, ativo }: { id: string; ativo: boolean }) => api.put(`/tipos-persiana/${id}`, { ativo }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['tipos-persiana'] }),
  });

  function openNew() { setForm(emptyForm); setEditId(null); setShowForm(true); }
  function openEdit(t: any) { setForm({ nome: t.nome, descricao: t.descricao || '' }); setEditId(t.id); setShowForm(true); }

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h1 className="text-xl font-bold">Tipos de Persiana</h1>
        <button onClick={openNew} className="btn-primary">+ Novo</button>
      </div>

      {isLoading ? <div className="text-center py-8 text-gray-400">Carregando...</div> : (
        <div className="space-y-2">
          {tipos.length === 0 && (
            <div className="text-center py-12 text-gray-400">
              <div className="text-4xl mb-2">🪟</div>
              <p>Nenhum tipo cadastrado. Crie o primeiro!</p>
            </div>
          )}
          {tipos.map((t: any) => (
            <div key={t.id} className={`card ${!t.ativo ? 'opacity-60' : ''}`}>
              <div className="flex items-start justify-between">
                <div>
                  <div className="font-medium">{t.nome}</div>
                  {t.descricao && <div className="text-sm text-gray-500 mt-0.5">{t.descricao}</div>}
                  {!t.ativo && <span className="text-xs text-gray-400">Inativo</span>}
                </div>
                <div className="flex gap-3">
                  <button onClick={() => openEdit(t)} className="text-sm text-blue-500">Editar</button>
                  <button onClick={() => toggleMutation.mutate({ id: t.id, ativo: !t.ativo })} className="text-sm text-red-500">
                    {t.ativo ? 'Desativar' : 'Ativar'}
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {showForm && (
        <div className="fixed inset-0 bg-black/50 z-40 flex items-end md:items-center justify-center">
          <div className="bg-white rounded-t-2xl md:rounded-2xl w-full md:max-w-md max-h-[90vh] overflow-y-auto">
            <div className="p-4 border-b flex justify-between items-center">
              <h3 className="font-semibold">{editId ? 'Editar Tipo' : 'Novo Tipo de Persiana'}</h3>
              <button onClick={() => setShowForm(false)}>✕</button>
            </div>
            <div className="p-4 space-y-3">
              <div>
                <label className="label">Nome *</label>
                <input
                  className="input"
                  placeholder="Ex: Romana, Rolo, Vertical, Veneziana..."
                  value={form.nome}
                  onChange={e => setForm({ ...form, nome: e.target.value })}
                />
              </div>
              <div>
                <label className="label">Descrição</label>
                <textarea
                  className="input resize-none"
                  rows={2}
                  placeholder="Descrição opcional..."
                  value={form.descricao}
                  onChange={e => setForm({ ...form, descricao: e.target.value })}
                />
              </div>
              <div className="flex gap-3 pt-2">
                <button onClick={() => setShowForm(false)} className="btn-secondary flex-1">Cancelar</button>
                <button
                  onClick={() => saveMutation.mutate(form)}
                  disabled={!form.nome || saveMutation.isPending}
                  className="btn-primary flex-1"
                >
                  {saveMutation.isPending ? 'Salvando...' : 'Salvar'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
